import { GetUserInfoService, GetUserInfoServiceRequest } from '@/services/user';

const initUserInformation = async () => {
  const getUserInfoServiceRequest = new GetUserInfoServiceRequest();
  const getUserInfoService = new GetUserInfoService(getUserInfoServiceRequest);
  return getUserInfoService.do();
};

export default { initUserInformation };
